
  window.DACModalComponent = function (dialogLabel) {
    if (customElements.get('modal-component')) return;

    const opened = new Set();
    let bodyHadLock = false, previousOverflow = '', previousOverflowPriority = '';
    let modalSequence = 0;
    class ModalComponent extends HTMLElement {
      constructor() {
        super();

        this.config = {
          id: this.getAttribute('data-id') || `dac-modal-${++modalSequence}`,
          title: this.getAttribute('data-title') || '',
          templateId: this.getAttribute('data-template-id'),
          onSuccess: this.onsubmit || null,
          onClose: this.getAttribute('data-onclose') || null,
          autoHeight: Boolean(this.getAttribute('data-auto-height')),
          successText: this.getAttribute('data-success-text') || 'Submit',
          cancelText: this.getAttribute('data-cancel-text') || "Avbryt",
          _modalTemplateId: `modal-template-${this.getAttribute('data-version') || 'v1'}`,
          _version: this.getAttribute('data-version') || 'v1',
        };
      }

      setConfig(config) {
        this.config = { ...this.config, ...(config || {}) };
      }

      open(opener = document.activeElement) {
        const existingModal = document.getElementById(this.config.id);
        if (existingModal) return;

        const modal = document.getElementById(this.config._modalTemplateId).content.cloneNode(true);
        const modalTitle = modal.getElementById('modal-title');
        const modalSection = modal.querySelector('section');
        const modalContent = modal.getElementById('modal-content');
        let modalSuccessText = modal.getElementById('modal-success-text');
        let modalCancelText = modal.getElementById('modal-cancel-text');
        let modalCloseTriggers = Array.from(modal.querySelectorAll('.modal-close-trigger'));
        const template = document.getElementById(this.config.templateId).content.cloneNode(true);

        if (this.config._modalTemplateId.includes('v3')) {
          modalSuccessText = template.getElementById('modal-success-text');
          modalCancelText = template.getElementById('modal-cancel-text');
          modalCloseTriggers = modalCloseTriggers.concat(Array.from(template.querySelectorAll('.modal-close-trigger')));
        }

        if (modalTitle) {
          modalTitle.textContent = this.config.title;
          modalTitle.dataset.modalTitle = '';
          modalTitle.id = this.config.id + '-title';
        }
        if (modalSuccessText) { modalSuccessText.dataset.modalSuccess = ''; modalSuccessText.id = this.config.id + '-success'; }
        if (modalCancelText) { modalCancelText.dataset.modalCancel = ''; modalCancelText.id = this.config.id + '-cancel'; }
        modalContent.dataset.modalContent = '';
        modalContent.id = this.config.id + '-content';
        if (modalSuccessText) modalSuccessText.innerText = this.config.successText;
        if (modalCancelText) modalCancelText.innerText = this.config.cancelText;

        if (this.config.autoHeight) {
          modalSection.style.height = 'auto';
        }

        this.parseVersionedContent(template);
        modalContent.appendChild(template);
        modalCloseTriggers.forEach((trigger) => trigger.addEventListener('click', this.close.bind(this)));
        if (modalSuccessText) modalSuccessText.addEventListener('click', this.config.onSuccess);

        const root = document.createElement('dialog');
        for (const attribute of modal.firstElementChild.attributes) root.setAttribute(attribute.name, attribute.value);
        root.classList.add('dac-component-dialog');
        root.id = this.config.id;
        root.append(...modal.firstElementChild.childNodes);
        if (modalTitle && this.config.title) root.setAttribute('aria-labelledby', modalTitle.id);
        else root.setAttribute('aria-label', this.config.title || dialogLabel);
        root.addEventListener('cancel', event => { event.preventDefault(); this.close(); });
        root.addEventListener('close', () => { if (this._dialog === root) this.close(); });
        this._opener = opener;
        this._dialog = root;
        if (!opened.size) {
          bodyHadLock = document.body.classList.contains('overflow-hidden');
          previousOverflow = document.body.style.getPropertyValue('overflow');
          previousOverflowPriority = document.body.style.getPropertyPriority('overflow');
        }
        opened.add(this);
        document.body.appendChild(root);
        document.body.classList.add('overflow-hidden');
        document.body.style.setProperty('overflow', 'hidden');
        root.showModal();
        const close = [...root.querySelectorAll('button.modal-close-trigger')].find(button => !button.disabled && button.getClientRects().length && getComputedStyle(button).display !== 'none');
        close?.focus({preventScroll:true});
      }

      close() {
        const modal = this._dialog;
        if (!modal || this._closing) return;
        this._closing = true;
        this._dialog = null;
        try {
          if (typeof this.config.onClose === 'string') {
            const windowFn = window[this.config.onClose];
            if (typeof windowFn === 'function') windowFn();
          } else if (typeof this.config.onClose === 'function') this.config.onClose();
        } finally {
          if (modal.open) modal.close();
          modal.remove();
          opened.delete(this);
          if (!opened.size) {
            if (!bodyHadLock) document.body.classList.remove('overflow-hidden');
            if (previousOverflow) document.body.style.setProperty('overflow', previousOverflow, previousOverflowPriority);
            else document.body.style.removeProperty('overflow');
          }
          const opener = this._opener;
          if (opener?.isConnected) opener.focus({preventScroll:true});
          // WebKit can retain modal background isolation until cancel/close finishes.
          // Retry on the next frame only if focus still rests on the page itself.
          requestAnimationFrame(() => {
            if (!this._dialog && this._opener === opener && opener?.isConnected && document.activeElement === document.body) {
              opener.focus({preventScroll:true});
            }
          });
          this._closing = false;
        }
      }

      /* Hide modal content in specific layout versions */
      parseVersionedContent(template) {
        const hideIn = template.querySelectorAll('[data-hide-if]');

        hideIn.forEach((element) => {
          const hidedIn = element.getAttribute('data-hide-if').split(',');

          hidedIn.forEach((version) => {
            if (this.config._version === version) {
              template.contains(element) && template.removeChild(element);
            }
          });
        });
      }
    }

    customElements.define('modal-component', ModalComponent);
  };
